var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "800",
      "title": `${_vm.openedSalesContract ? '编辑' : '新增'}销售合同`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top",
      "loading": _vm.customerLoading
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "label": "客户",
      "prop": "customer"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.openedSalesContract ? true : false,
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "placeholder": "请选择客户"
    },
    model: {
      value: _vm.formItem.customer,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "customer", $$v);
      },
      expression: "formItem.customer"
    }
  }, _vm._l(_vm.customersSimple, function (option) {
    return _c('Option', {
      key: option._id,
      staticStyle: {
        "width": "366px"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "合同编号",
      "prop": "number"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "合同编号"
    },
    model: {
      value: _vm.formItem.abbr,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "abbr", $$v);
      },
      expression: "formItem.abbr"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "我方公司",
      "prop": "company"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "我方公司"
    },
    model: {
      value: _vm.formItem.abbr,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "abbr", $$v);
      },
      expression: "formItem.abbr"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "开始时间",
      "prop": "startDate"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择开始时间"
    },
    model: {
      value: _vm.formItem.startDate,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "startDate", $$v);
      },
      expression: "formItem.startDate"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "到期时间",
      "prop": "endDate"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择到期时间"
    },
    model: {
      value: _vm.formItem.endDate,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "endDate", $$v);
      },
      expression: "formItem.endDate"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "账期月数",
      "prop": "estAging"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0
    },
    model: {
      value: _vm.formItem.estAging,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "estAging", $$v);
      },
      expression: "formItem.estAging"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }